var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"horarios-layout",attrs:{"id":"horarios","aria-label":"Horarios y eventos"}},[_c('HorariosList',{attrs:{"horarios":_vm.horarios,"loading":_vm.loading,"error":_vm.error}}),_c('EventosCalendario')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }